import React, { useState } from 'react'
import { Loader, Modal } from 'rsuite'

import { AddToEventButton as MyButton } from '../../Activity/ActivityStyledComponents'
import { colors } from '../../Styles/common-styles'
import styles from '../../AdminPanel/styles'
import { SuccessArrow, ErrorCross, SendTG } from '../../Icons'

const sendResetEmail = async (
  userEmail, resetPassword, setLoading, setStatusOfResponse
) => {
  setLoading(true)
  try {
    await resetPassword(userEmail)
    setStatusOfResponse('ok')
  } catch (err) {
    console.log(err)
    setStatusOfResponse(err.message)
  }
  setLoading(false)
}

const SimpleUser = ({
  userData, resetPassword,
  setModalVisible, setLoading, loading
}) => {
  const [statusOfResponse, setStatusOfResponse] = useState(false)
  const userName = userData.displayName
  const userEmail = userData.email
  // console.log(setStatusOfResponse)
  return (
    <>
      {!statusOfResponse
        ? <>
          {loading && <Loader backdrop size='lg' content='loading...' vertical />}
          <Modal.Header>
            <Modal.Title style={styles.modalTitle1}>
              Do you want to send reset password email to
            </Modal.Title>
            <Modal.Title style={styles.modalTitle1}>
              user '{userName} - {userEmail}' ?
            </Modal.Title>
            <Modal.Title style={styles.modalTitle2}>
              If it's ok, click on 'Send' button
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={styles.modalBody}>
            {!loading && <SendTG stroke={colors.purpleMain} size={80} />}
          </Modal.Body>
          <Modal.Footer style={styles.modalFooter}>
            <MyButton cancel onClick={() => setModalVisible(false)}>No, thanks </MyButton>
            <MyButton
              onClick={() => {
                sendResetEmail(userEmail, resetPassword, setLoading, setStatusOfResponse)
              }}>Just do it </MyButton>
          </Modal.Footer>
        </>
        : <>
          {statusOfResponse === 'ok'
            ? <>
              <Modal.Header>
                <Modal.Title style={styles.modalTitle1}>
                  Email was succesfully sent to user '{userName} - {userEmail}'
                </Modal.Title>
                <Modal.Title style={styles.modalTitle2}>
                  Now you can close this modal
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={styles.modalBody}>
                <SuccessArrow stroke={colors.green} />
              </Modal.Body>
              <Modal.Footer style={styles.modalFooter}>
                <MyButton
                  reverse
                  onClick={() => setModalVisible(false)}
                >Close</MyButton>
              </Modal.Footer>
            </>
            : <>
              <Modal.Header>
                <Modal.Title style={styles.modalTitle1}>
                  Something went wrong
                </Modal.Title>
                <Modal.Title style={styles.modalTitle2}>
                  {statusOfResponse}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={styles.modalBody}>
                <ErrorCross stroke={colors.errorRed} />
              </Modal.Body>
              <Modal.Footer style={styles.modalFooter}>
                <MyButton reverse onClick={() => setModalVisible(false)}>Close</MyButton>
              </Modal.Footer>
            </>}
        </>}
    </>
  )
}

export default SimpleUser
